'use client';

import { useEffect, useState } from 'react';

const usePrefersReducedMotion = () => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState<boolean>(true);

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`);
    setPrefersReducedMotion(prefersReducedMotion.matches);
    const listener = (event: MediaQueryListEvent) => {
      setPrefersReducedMotion(event.matches);
    };

    try {
      prefersReducedMotion.addEventListener('change', listener);
      return () => {
        prefersReducedMotion.removeEventListener('change', listener);
      };
    } catch (_error) {
      // Fallback for Safari < 14 and older browsers
      window.matchMedia(`(prefers-reduced-motion: reduce)`).addListener(listener);
      return () => {
        window.matchMedia(`(prefers-reduced-motion: reduce)`).removeListener(listener);
      };
    }
  }, []);
  return prefersReducedMotion;
};

export { usePrefersReducedMotion };
